import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";





'use strict';





var helpers = {

  radioButton: function(data) {
    var requiredAttrs = ["id"],
      reservedAttrs = ["type","data-mask","data-gis-mask","name"],
      combinableAttrs = {"class": "spa-input-option spa-input-option--radio", "value": ""},
      attrsStr,
      radioButtonString="",
      output;

    for(var i=0, len=data.radioButtons.length;i<len;i++) {
      var radioButton = data.radioButtons[i];

      if(!Handlebars.helpers.requiredAttrsCheck(radioButton.radioButton.attrs,requiredAttrs).pass) {

        throw new Error("You are missing the required attribute " + Handlebars.helpers.requiredAttrsCheck(radioButton.radioButton.attrs,requiredAttrs).missingField);


        if(window.console && console.log) {
          console.log("You are missing the required attribute " + Handlebars.helpers.requiredAttrsCheck(radioButton.radioButton.attrs,requiredAttrs).missingField);
          return "";
        }
      }
      Handlebars.helpers.removeReservedAttrs(radioButton.radioButton.attrs,reservedAttrs);
      Handlebars.helpers.combineAttrs(radioButton.radioButton.attrs,combinableAttrs);
      attrsStr = Handlebars.helpers.buildAttrsString(radioButton.radioButton.attrs);

      radioButtonString +=
      '<li> \
          <input type="radio" '+attrsStr+' '+((data.required) ? 'required' : '' )+' name="'+data.name+'" /> \
          <span class="spa-input-check">&nbsp;</span> \
          <label class="spa-input-option-label" for="'+radioButton.radioButton.attrs.id+'">'+radioButton.label.text+'<span class="ada-hidden"> '+((radioButton.label.adaText) ? radioButton.label.adaText : '')+'</span></label> \
      </li>';
    }

    output = '<div class="spa-input spa-input-options spa-input--'+((data.skin) ? data.skin : 'material-design')+' '+((data.containerClasses) ? data.containerClasses.join(' ') : '')+'">' +
                ((data.label) ? '<label class="spa-input-options-label">' + data.label + ((data.required) ? '<span class="spa-input-label--required"> *</span>' : '' ) + '</label>' : '') +
                '<ul class="spa-input-options-list">'
                  +radioButtonString+
                '</ul> \
                <p class="spa-input-options-hint">'+((data.hintText) ? data.hintText : '')+'</p> \
            </div>';

    return new Handlebars.SafeString(output);
  }
};



module.exports.register = function (Handlebars, options) {
  options = options || {};
  for (var helper in helpers) {
    if (helpers.hasOwnProperty(helper)) {
      Handlebars.registerHelper(helper, helpers[helper]);
    }
  }
};


module.exports.helpers = helpers;
